import React from 'react';

// CONTEXT
import { useRecordContext } from 'helpers/getRecordData';

// BOOTSTRAP COMPONENTS
import { Badge } from 'react-bootstrap';

// PROTOTYPE
import Log from '../prototype/Log';

// LOCAL PARTS
import DealTasksCollapse from './dealTasksLog/DealTasksCollapse';
import DealTasksItem from './dealTasksLog/DealTasksItem';
import DealTasksPill from './dealTasksLog/DealTasksPill';

// STYLES
import styles from './dealTasksLog.module.scss';

// MAIN COMPONENTS
const DealTasksLog = props => {

  const {
    record: {
      aryCompletedDealTasks,
      aryPendingDealTasks
    } = {},
  } = useRecordContext() || {};

  // RENDER
  return (
    <Log
      {...props}
    >
      {[{
        title: 'Open Tasks',
        tools: !!aryPendingDealTasks?.length && <Badge className={styles.incompletePill} bg="danger" pill>{`${aryPendingDealTasks.length} Incomplete`}</Badge>,
        items: aryPendingDealTasks
      },
      {
        title: 'Completed Tasks',
        items: aryCompletedDealTasks
      }].map(({ items, ...itemProps }, i) => (
        <DealTasksCollapse
          key={i}
          {...itemProps}
        >
          {!!items?.length ? items.map((item, i) => (
            <DealTasksItem
              key={item.task_id}
              number={i + 1}
              name={props.name}
              {...item}
            />
          )) : <p>No {itemProps.title.toLowerCase()}.</p>}
        </DealTasksCollapse>
      ))}
    </Log>
  );
};

// EXPORT
DealTasksLog.Tab = props => <Log.Tab pill={DealTasksPill} {...props} />;
export default DealTasksLog;
